/**
 * In this file use to contains the physician Module MedicalIssues screen UI and Logic
 **/
import { Link } from "react-router-dom";
import { goBack } from "./../../../services/UtilsService";
import { useState, useEffect } from "react";
import ApiService from "./../../../services/ApiService";
import Pagination from "./../../../shared/components/Pagination";
import {
  convertDOBtoAge,
  convertUTCtoLocal,
  convertS3privateToPublic,
  convertUTCtoDate,
} from "./../../../services/UtilsService";
import MedicalIssueModal from "./../../../shared/modals/MedicalIssueModal";
import VitalsModal from "./../../../shared/modals/VitalsModal";
import DiagnosisAddModal from "./../../../shared/modals/DiagnosisAddModal";
import DiagnosisViewModal from "./../../../shared/modals/DiagnosisViewModal";
import { useTranslation } from 'react-i18next';

function MedicalIssues() {
  //Intial state declaraction
  const [list, setList] = useState([]);
  const [request, setRequest] = useState({ page: 0, limit: 10 });
  const [count, setCount] = useState(0);
  const [modal, setModal] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();
  
  //Component Initialize function
   useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true); 
      try {
        const response = await ApiService.listMedicalIssues(request);
        if (response.status === 200) {
          setList(response.data.items);
          setCount(response.data.count);
        }
      } catch (error) {
        console.error('Error fetching member medical issues:', error);
      } finally {
        setIsLoading(false); 
      }
    };

    fetchData();
  }, [request]);

  /**
   *To handle pagination event
   * @data we pass the page number
   **/
  const handlePaginate = (data) => {
    setRequest((req) => ({ ...req, page: data }));
  };

  //To close modal
  const handleClose = () => setModal({});

  return (
    <>
      {/*Import MedicalIssueModal*/}
      {Object.keys(modal).length !== 0 && modal.medication && (
        <MedicalIssueModal data={modal} handleClose={handleClose} />
      )}

      {/*Import VitalsModal*/}
      {Object.keys(modal).length !== 0 && modal.showVitals && (
        <VitalsModal data={modal} handleClose={handleClose} />
      )}

      {/*Import DiagnosisAddModal*/}
      {Object.keys(modal).length !== 0 && modal.addDiagnosis && (
        <DiagnosisAddModal data={modal} handleClose={handleClose} />
      )}

      {/*Import DiagnosisViewModal*/}
      {Object.keys(modal).length !== 0 && modal.viewDiagnosis && (
        <DiagnosisViewModal data={modal} handleClose={handleClose} />
      )}

      <main id="main" className="main">
        <div className="pagetitle clearfix">
          <div className="float-start">
            <h1>{t('sidebar.medicalIssues')}</h1>
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/physician/dashboard">
                    {t('sidebar.home')}
                  </Link>
                </li>
                <li className="breadcrumb-item active">
                  {t('sidebar.medicalIssues')}{" "}
                </li>
              </ol>
            </nav>
          </div>
          <div className="float-end mt-2 me-1">
            <span onClick={goBack} className="backIcon">
              <i className="iconly-Bold-ArrowLeftSquare"></i>
            </span>
          </div>
        </div>
        {/*Page Content Section*/}
        <section className="pagesection">
          {/*Search*/}
          <div className="row my-3">
            <div className="col-xxl-7 col-lg-7 d-flex">
              <div className="input-group input-group-sm me-2 w-50">
                <input
                  type="text"
                  onChange={(e) =>
                    setRequest((req) => ({
                      ...req,
                      search: e.target.value,
                      page: 0,
                    }))
                  }
                  className="form-control"
                  placeholder={t('common.search')}
                />
                <button className="btn btn-tmBlue" type="button">
                  <i className="ri-search-line align-middle"></i>
                </button>
              </div>
            </div>
            <div className="col-xxl-5 col-lg-5">
              <div className="dropdown float-end me-3">
                <a
                  className="btn btn-sm btn-outline-tmBlue dropdown-toggle"
                  href="!#"
                  role="button"
                  id="dropdownMenuLink"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {t('common.sort')}
                </a>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuLink"
                >
                  <li
                    onClick={() =>
                      setRequest((req) => ({ ...req, sort: "created" }))
                    }
                  >
                    <span
                      className={
                        request.sort === "created"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                    >
                      {" "}
                      {t('common.recentAdded')}
                    </span>
                  </li>
                  <li
                    onClick={() =>
                      setRequest((req) => ({ ...req, sort: "updated" }))
                    }
                  >
                    <span
                      className={
                        request.sort === "updated"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                    >
                      {" "}
                      {t('common.recentUpdated')}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/*End Search*/}
          {/*Table*/}
          <div className="row my-3">
            <div className="col-xxl-12">
              <div className="table-responsive">
                <table className="table table-borderless theme-table">
                  <thead>
                    <tr>
                      <th width={250}>
                        {t('table.memberDetails')}
                      </th>
                      <th>{t('table.issueDate')}</th>
                      <th>{t('table.mainProblem')}</th>
                      <th>{t('table.associatedProblem')}</th>
                      <th>{t('table.vitals')}</th>
                      <th>{t('table.diagnosis')}</th>
                      <th className="text-center">
                        {t('table.more')}
                      </th>
					   <th className="text-center">
                        {t('table.add')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {list &&
                      list.length !== 0 &&
                      list.map((item, i) => (
                        <tr
                          key={i}
                          className={
                            item.gender === 1
                              ? "female text-capitalize"
                              : "male text-capitalize"
                          }
                        >
                          <td>
                            <div className="d-flex  align-items-center ps-1">
                              <div className="avtar-img">
                                <span className="rounded-circle">
                                  {item?.photo === "default.png" ? (
                                    <img
                                      src="/assets/img/user-avatar.png"
                                      alt="UN"
                                    />
                                  ) : (
                                    <img
                                      src={convertS3privateToPublic(
                                        item?.photo
                                      )}
                                      alt="UN"
                                    />
                                  )}
                                </span>
                              </div>
                              <div className="ms-3">
                                <Link
                                  to={
                                    "/physician/member-profile/" + item?.member
                                  }
                                >
                                  <h5 className="table-title fw-bold">
                                    {item.name}
                                  </h5>
                                </Link>
                                <p className="table-subtitle">
                                  <span>
                                    {item?.gender === 0 ? t('common.boy') :  t('common.girl')}
                                  </span>{" "}
                                  - {convertDOBtoAge(item.dob, t)}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td>{convertUTCtoLocal(item.createdAt)}</td>
                          <td>{item.main_problem}</td>
                          <td className="text-left">
                            {item.associated_problem +
                              " - " +
                              convertUTCtoDate(item.createdAt)}
                            <br />
                            {item.update_associated_problem.map(
                              (data, index) => (
                                <div key={index}>
                                  {data.associated_problem} -{" "}
                                  {convertUTCtoDate(data.updatedDate)}
                                </div>
                              )
                            )}
                          </td>
                          <td>
                            <span
                              onClick={() =>
                                setModal({
                                  showVitals: true,
                                  vitalsValue: item.vitals,
                                  member: item.member,
                                  parent: item.parent,
                                })
                              }
                              className="table-link text-tmBlue"
                            >
                              <i
                                className="fa-solid fa-heart-pulse"
                                toggle="tooltip"
                                placement="top"
                                title= {t('common.viewVitals')}
                              ></i>
                            </span>
                          </td>
                          <td>
                            <div className="d-flex justify-content-around">
                              <span
                                onClick={() =>
                                  setModal({
                                    addDiagnosis: true,
                                    member: item.member,
                                    parent: item.parent,
									dob: item.dob,
                                    report_id: item.id,
                                  })
                                }
                                className="table-link text-tmPink"
                              >
                                <i
                                  className="fa-solid fa-suitcase-medical me-2"
                                  toggle="tooltip"
                                  placement="top"
                                  title= {t('modal.addDiagnosis')}
                                />
                              </span>
                              <span
                                onClick={() =>
                                  setModal({
                                    viewDiagnosis: true,
                                    id: item.id,
                                    name: item.name,
                                    dob: item.dob,
                                  })
                                }
                                className="table-link text-tmBlue"
                              >
                                <i
                                  className="fa-solid fa-file-lines"
                                  toggle="tooltip"
                                  placement="top"
                                  title= {t('modal.viewDiagnosis')}
                                />
                              </span>
                            </div>
                          </td>
                          <td className="text-center">
                            <span
                              onClick={() =>
                                setModal({
                                  medication: true,
                                  member: item.member,
                                  parent: item.parent,
                                  name: item.name,
                                  dob: item.dob,
                                })
                              }
                              className="table-link text-tmBlue"
                            >
                              <i className="fa-solid fa-hospital-user" />
                            </span>
                          </td>
						  <td className="text-center">
							<Link to={'/physician/add-medical-issues/'+item.member} className="table-link text-tmBlue"><i className="ri-add-box-fill align-middle fw-normal"></i> 
							</Link> </td>
                        </tr>
                      ))}
                    {list.length === 0 && !isLoading &&  (
                      <tr>
                        <td colSpan="11" className="text-center">
                          {t('common.noRecord')}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/*End Table*/}
          {/*Pagination*/}
          <div className="row my-3">
            <div className="col-xxl-12 d-flex justify-content-center">
              {list.length !== 0 && (
                <Pagination
                  page={request.page}
                  handlePaginate={handlePaginate}
                  total={count}
                />
              )}
            </div>
          </div>
          {/*End Pagination*/}
        </section>
        {/*End Page Content Section*/}
      </main>
    </>
  );
}

export default MedicalIssues;
